import { render, staticRenderFns } from "./WorkRegist.vue?vue&type=template&id=2728df5c"
import script from "./WorkRegist.vue?vue&type=script&lang=js"
export * from "./WorkRegist.vue?vue&type=script&lang=js"
import style0 from "./WorkRegist.vue?vue&type=style&index=0&id=2728df5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports